export default __webpack_public_path__ + "static/media/affisch_1_a3_home_printer.129ffff1.png";